import { Flex, Spinner } from '@optiaxiom/react';

const FullScreenLoader = () => {
  return (
    <Flex justifyContent="center" alignItems="center" h="full">
      <Spinner size="xl" />
    </Flex>
  );
};

export default FullScreenLoader;
